import { ChangeDetectionStrategy, Component, NO_ERRORS_SCHEMA, ViewChild } from '@angular/core';
import { DeviceBaseComponent } from '../../device-base/device-base.component';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-yealink-t77',
  templateUrl: './yealink-t77.component.html',
  styleUrls: ['../../device-base/device-base.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [DeviceBaseComponent, NgClass],
  schemas: [NO_ERRORS_SCHEMA],
})
export class YealinkT77Component {
  @ViewChild('base') base!: DeviceBaseComponent;
}
